<template>
	<v-container class="pt-0">
		<v-row no-gutters>
			<v-col>
				<v-card class="elevation-1 justify-center text-center" color="white">
					<v-card-title @click="cancelLocumSearch()">
						<v-btn text class="secondary--text font-weight-bold"> <v-icon large color="secondary" @click="cancelLocumSearch()">keyboard_backspace</v-icon>Back </v-btn>
						<v-spacer></v-spacer>
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<!--the card -->
						<v-row readonly flat>
							<v-col>
								<v-list-item>
									<v-list-item-content align="center" justify="center">
										<v-list-item-title class="title font-weight-black" v-text="'Booking Sent'"></v-list-item-title>
									</v-list-item-content>
								</v-list-item>
							</v-col>
						</v-row>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-text>
						<v-row readonly flat>
							<v-col>
								<v-list-item style="font-family: Montserrat;font-style: normal;font-weight: normal;font-size: 16px;line-height: 20px; !important">
									Do you want to book another locum for the same dates?
								</v-list-item>
							</v-col>
						</v-row>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-row>
							<v-col>
								<v-btn outlined style="background: #ffffff; border: 1px solid primary; box-sizing: border-box; border-radius: 100px" @click="cancelLocumSearch()"
									><div
										style="
											font-family: Montserrat;
											font-style: normal;
											font-weight: bold;
											font-size: 16px;
											line-height: 20px;
											text-align: center;
											color: var(--v-primary-base);
										"
									>
										Not Now
									</div></v-btn
								>
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<v-btn style="background: var(--v-primary-base); box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05); border-radius: 100px" @click="performNewSearch"
									><div
										style="
											font-family: Montserrat;
											font-style: normal;
											font-weight: bold;
											font-size: 16px;
											line-height: 20px;
											text-align: center;
											color: #ffffff;
										"
									>
										Yes, Continue
									</div></v-btn
								>
							</v-col>
						</v-row>
					</v-card-actions>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import { bus } from '@/main';

export default {
	name: 'PracticeRequestMultipleLocums',
	methods: {
		cancelLocumSearch() {
			bus.$emit('change-context', 'practice-dashboard-landing-zone');
		},
		async performNewSearch() {
			bus.$emit('change-context', 'practice-locum-search-results');
		},
	},
};
</script>
